<template>
  <md-popup
    v-model="dialogVisible"
    class="withdraw-popup"
    @hide="hideDialog"
  >
    <div class="limitation-header">
      {{ $t('limitationHead')}}
    </div>
    <div class="item">
      <div class="item-title">
        <img src="@/assets/image/withdraw/bca_logo.png" class="item-logo" width="65" height="20" alt="BCA">
      </div>
      <div class="item-section">
        <div class="item-label">{{ $t('maxLabel') }}</div>
        <div class="item-desc">{{ $t('perTransaction') }} {{ $t('noLimit') }}</div>
      </div>
      <div class="item-section">
        <div class="item-label">{{ $t('minLabel') }}</div>
        <div class="item-desc">{{ $t('perTransaction') }} Rp 10.000</div>
      </div>
    </div>
    <div class="item">
      <div class="item-title">
        <img src="@/assets/image/withdraw/bank_logo.png" class="item-logo" width="266" height="59" alt="bank">
      </div>
      <div class="item-section">
        <div class="item-label">{{ $t('maxLabel') }}</div>
        <div class="item-desc">{{ $t('perTransaction') }} {{ $t('noLimit') }}</div>
      </div>
      <div class="item-section">
        <div class="item-label">{{ $t('minLabel') }}</div>
        <div class="item-desc">{{ $t('perTransaction') }} Rp 10.000</div>
      </div>
    </div>
    <div class="item">
      <div class="item-title">{{ $t('otherBanks') }}</div>
      <div class="item-section">
        <div class="item-label">{{ $t('maxLabel') }}</div>
        <div class="item-desc">{{ $t('perTransaction') }} Rp 50.000.000</div>
      </div>
      <div class="item-section">
        <div class="item-label">{{ $t('minLabel') }}</div>
        <div class="item-desc">{{ $t('perTransaction') }} Rp 10.000</div>
      </div>
    </div>
  </md-popup>
</template>

<script>
import { Popup } from 'mand-mobile'
import dialogMixins from '@/mixins/dialog'

export default {
  i18n: {
    messages: {
      en: {
        limitationHead: 'Limitations of payment amount',
        maxLabel: 'Maximum Amount',
        minLabel: 'Minimum Amount',
        perTransaction: 'Per Transaction :',
        noLimit: 'No Limit',
        otherBanks: 'Other Banks',
      },
      id: {
        limitationHead: 'Limit jumlah penarikan',
        maxLabel: 'Penarikan maximum  ',
        minLabel: 'Penarikan minimum',
        perTransaction: 'Per Transaksi :',
        noLimit: 'Tidak terbatas',
        otherBanks: 'Bank Lainnya',
      },
    },
  },
  components: {
    [Popup.name]: Popup,
  },
  mixins: [dialogMixins],
}
</script>

<style scoped lang="stylus">
.withdraw-popup /deep/ {
  .md-popup-box {
    width: 90%;
    max-height: 60%;
    overflow-y: scroll;
    padding: 40px 20px;
    background-color: #fff;
    border-radius: 6px;
  }
}

.limitation-header {
  font-size: 16px;
  font-weight: bold;
}

.item {
  padding-top: 20px;
  border-bottom: 1px solid #ccc;
  font-size: 14px;
  .item-title {
    margin: 10px 0 20px;
  }
  .item-section {
    margin-bottom: 20px;
    .item-label {
      line-height: 17px;
      color: #333;
      margin-bottom: 8px;
    }
    .item-desc {
      font-weight: 500;
    }
  }
  &:last-child {
    border-bottom: 0;
  }
}
</style>
